import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { taskRelationService } from '@services';

export const useTaskRelations = (taskId, options = {}) => {
  return useQuery({
    queryKey: ['taskRelations', taskId],
    queryFn: () => taskRelationService.getByTaskId(taskId),
    enabled: !!taskId,
    ...options,
  });
};

export const useProjectRelations = (projectId, options = {}) => {
  return useQuery({
    queryKey: ['projectRelations', projectId],
    queryFn: () => taskRelationService.getByProjectId(projectId),
    enabled: !!projectId,
    ...options,
  });
};

export const useCreateTaskRelation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: taskRelationService.create,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['taskRelations', variables.sourceTaskId] });
      queryClient.invalidateQueries({ queryKey: ['taskRelations', variables.targetTaskId] });
      queryClient.invalidateQueries({ queryKey: ['projectRelations'] });
      queryClient.invalidateQueries({ queryKey: ['tasks'] });
    },
  });
};

export const useDeleteTaskRelation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: taskRelationService.delete,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['taskRelations'] });
      queryClient.invalidateQueries({ queryKey: ['projectRelations'] });
      queryClient.invalidateQueries({ queryKey: ['tasks'] });
    },
  });
};
